import React from 'react';
import { useAppDispatch } from '../../../../../store/hooks';
import { Text } from '../../../../../components/Typography';
import { ConversationPreview } from '../../../../../store/chat/types';
import { Popover } from '../../../../../components/UI';
import { IconEllipsis } from '../../../../../components/Icon';
import { openModal } from '../../../../../store/chat/slice';
import styles from './ConversationItem.module.scss';
import ConversationStatus from './ConversationStatus';
import ConversationTags from './ConversationTags';

interface ConversationItemProps {
  conversation: ConversationPreview;
  isActive: boolean;
  onClick: (conversation: ConversationPreview) => void;
}

const ConversationItem: React.FC<ConversationItemProps> = ({ conversation, isActive, onClick }) => {
  const dispatch = useAppDispatch();

  const handleContainerClick = (e: React.MouseEvent) => {
    // Don't trigger onClick when clicking the action button
    if (e.target instanceof Element && e.target.closest(`.${styles.actionButton}`)) {
      return;
    }
    onClick(conversation);
  };

  const handleRename = (e: React.MouseEvent) => {
    e.stopPropagation();
    dispatch(openModal({ type: 'rename', conversationId: conversation.id }));
  };

  const handleDelete = (e: React.MouseEvent) => {
    e.stopPropagation();
    dispatch(openModal({ type: 'delete', conversationId: conversation.id }));
  };

  return (
    <div
      className={`${styles.container} ${isActive ? styles.active : ''}`}
      onClick={handleContainerClick}
    >
      <div className={styles.content}>
        <div className={styles.titleContainer}>
          <div className={styles.statusWrapper}>
            <ConversationStatus status={conversation.status} />
          </div>
          <Text weight="medium" className={styles.title}>
            {conversation.title || 'Untitled conversation'}
          </Text>
        </div>
        <ConversationTags tickers={conversation.filtered_company_tickers || []} />
      </div>

      <div className={styles.actionButton} onClick={(e) => e.stopPropagation()}>
        <Popover trigger={<IconEllipsis size={18} color="var(--text-light)" />}>
          {(closePopover) => (
            <>
              <div
                className={styles.menuItem}
                onClick={(e) => {
                  handleRename(e);
                  closePopover();
                }}
              >
                <Text>Rename</Text>
              </div>
              <div className={styles.menuDivider} />
              <div
                className={styles.menuItem}
                onClick={(e) => {
                  handleDelete(e);
                  closePopover();
                }}
              >
                <Text color="coral">Delete</Text>
              </div>
            </>
          )}
        </Popover>
      </div>
    </div>
  );
};

export default ConversationItem;
